import React from 'react';

const Button = ({ imgIcon, SvgIcon, label, action, color, isActive }) => (
  <div className={`App-button ${isActive ? 'active' : ''}`} onClick={action}>
    { imgIcon && <img src={imgIcon} alt="button icon" className="App-button-icon" style={{backgroundColor: color || "default"}} /> }
    { SvgIcon && <SvgIcon className="App-button-icon" style={{backgroundColor: color || "default"}} /> }
    { label && <div className="App-button-label">{label}</div> }
  </div>
)

export default Button;